import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import QueryString from "qs";
import { signOut } from "../Loginxxx/loginSlice";
import { setShowErrors, setErrorMessage } from "../Errorsxx/errorsSlice";

const prepareQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_CIMA_ENDPOINT,
  mode: "cors",
  timeout: process.env.REACT_APP_CIMA_TIMEOUT,
  credentials: "include",
  prepareHeaders: (Headers, { getState }) => {
    const token = getState().cimaxxxx.token;
    Headers.set("Accept", "application/json");
    Headers.set("Content-Type", "application/json");
    if (token) {
      Headers.set("Authorization", `Bearer ${token}`);
    }
    return Headers;
  },
  paramsSerializer: (params) => {
    return QueryString.stringify(params);
  },
});

const baseQueryWithLogOut = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  switch (result?.error?.status) {
    case 401:
      api.dispatch(signOut());
      break;
    case 403:
    case 422:
    case 500:
      api.dispatch(setShowErrors(true));
      api.dispatch(
        setErrorMessage(result?.error?.data?.errors ? result?.error?.data?.errors : ["Se presentaron problemas al realizar la peticion"])
      );
      break;
    default:
      break;
  }
  return result;
};

const baseQuery = async (args, api, extraOptions) => {
  let getData = await prepareQuery(args, api, extraOptions);
  return getData;
};

export const cimaxxxxApiSlice = createApi({
  reducerPath: "cimaxxxxApiSlice",
  baseQuery: baseQueryWithLogOut,
  overrideExisting: true,
  endpoints: (builder) => ({
    loginCima: builder.mutation({
      query: (credentials) => ({
        url: "/loginCima",
        method: "POST",
        body: {
          USRIDXXX: credentials.USRIDXXX,
          USRPASXX: credentials.USRIDXXX,
          SISTEMAX: "CIMA",
          EXTERNAL: true,
        },
        credentials: "include",
        headers: {
          Modulecima: "usuarios",
        },
      }),
    }),
    // endpoint para consultar la Funcion Transportadora
    getTransporter: builder.query({
      query: (filter) => ({
        url: `/Doctraxx/Saldoctr/getTransportadorInt?filter=${filter}`,
        method: "GET",
        headers: {
          Modulecima: "doctraxx",
        },
      }),
    }),
    // endpoint para consultar clientes en base de datos cima
    getCimaClient: builder.query({
      query: (filter) => ({
        url: `Modclixx/Fichacli?page=1&per_page=15&sorts=CIPO0024.REGESTXX&${filter}`,
        method: "GET",
        headers: {
          Modulecima: "Modclixx",
        },
      }),
    }),
    getUsersCimaById: builder.query({
      query: (filter) => ({
        url: `Paramgen/Usuarios/getUserById/${filter.USRIDXXX}`,
        method: "GET",
        headers: {
          Modulecima: "Paramgen",
        },
      }),
    }),
    getUsrController: builder.query({
      query: (filter) => ({
        url: `Paramgen/Controlx/getUsersByModule/${filter.CLIIDXXX}/${filter.APLALLXX}?${filter.filter}`,
        method: "GET",
        headers: {
          Modulecima: "Paramgen",
        },
      }),
    }),
    getTransLoc: builder.query({
      query: (filter) => ({
        url: `Paramgen/Transloc/getIdTransport/${filter.TRALIDXX}`,
        method: "GET",
        headers: {
          Modulecima: "Paramgen",
        },
      }),
    }),
    getDoByClientId: builder.query({
      query: (filter) => ({
        url: `Registxx/Tracvuce/getDoByClientId/${filter.CLIIDXXX}/${filter.DOCNROXX}`,
        method: "GET",
        headers: {
          Modulecima: "Registxx",
        },
      }),
    }),
  }),
});

export const {
  useLoginCimaMutation,
  useLazyGetCimaClientQuery,
  useLazyGetTransporterQuery,
  useLazyGetTransLocQuery,
  useLazyGetUsersCimaByIdQuery,
  useLazyGetDoByClientIdQuery,
  useLazyGetUsrControllerQuery
} = cimaxxxxApiSlice;
